import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  updateGooglePlatform,
  updatePlatform,
  setCategory,
} from "../../actions";
import { isMobile } from "react-device-detect";
import { Menu } from "semantic-ui-react";
import { createStructuredSelector } from "reselect";
import {
  selectCategories,
  selectPlatform,
  selectUrlParams,
  selectMultirow,
  selectCategoryID,
  selectEmbedded
} from "../../selectors/global.selector";
import { setSocial } from "../utils/Amplitude";
import { platformStrategy, allPlatforms } from "../utils/sharing";
import { StyledMenu } from "../styled-components";

const Navbar = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const whitelabel = state.sharer.whitelabel;

  const structuredSelector = createStructuredSelector({
    urlParam: selectUrlParams,
    platform: selectPlatform,
    multirow: selectMultirow,
    categories: selectCategories,
    categoryID: selectCategoryID,
    isEmbedded: selectEmbedded,
  });
  const selectedState = structuredSelector(state);
  const { urlParam, platform, multirow, categories, categoryID, isEmbedded } =
    selectedState;
  const [transparentNavbar, setTransparentNavbar] = useState(false);

  const toPlatform = (thisPlatform) => {
    dispatch(setCategory(""));

    const newUrl = `/campaign/${props.campaignID}/ready_made_post/${thisPlatform}` + (urlParam ?? "");
    if(isEmbedded) {
      history.replace(newUrl);
    } else {
      history.push(newUrl);
    }

    const properName = platformStrategy(thisPlatform).config.platformName;;
    dispatch(updateGooglePlatform(properName));
    dispatch(updatePlatform(thisPlatform));    
    setSocial({ Social: thisPlatform });
  };

  useEffect(() => {
    // Transparent background for web embed
    if (isEmbedded && !multirow && categories && (categories.length <= 1 || categoryID !== null)) {
      setTransparentNavbar(true);
    } else {
      setTransparentNavbar(false);
    }
  }, [isEmbedded, categories, multirow, categoryID])

  const ImageToggleOnMouseOver = (props) => {
    const imageRef = useRef(null);  
    return (
      <img 
        onMouseOver={() => {
          if(!props.selected) {
            imageRef.current.src = props.activeImg;
          }
        }}
        onMouseOut={() => {
          if(!props.selected) {
            imageRef.current.src= props.inactiveImg;
          }
        }}
        src={props.selected ? props.activeImg : props.inactiveImg} 
        alt={props.alt}
        title={props.title}
        ref={imageRef}
        className={props.className}
        style={{"--platform_color": props.platformColor}}
      />
    )
  }

  // pre-load images
  useEffect(() => {
    allPlatforms.map((thisPlatform) => {
      if(props.socialNetworks[thisPlatform] && (platform !== thisPlatform)) {
        const strategy = platformStrategy(thisPlatform);
        const img = new Image();
        img.src = strategy.res.logo;
      }
    })
  },[props]);

  const navBarClassName = () => {
    let name = isEmbedded ? (isMobile ? "embedded-navbar embedded-navbar-mobile" : "embedded-navbar")
    : (categories.length > 1 ? "posts-navbar" : "posts-navbar box-shadow");

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const align = urlParams.get("align");
    if(align === "left") {
      name = name + " left";
    } else if(align === "right") {
      name = name + " right";
    } else if(align === "center") {
      name = name + " centered";
    } else if(align === "even") {
      name = name + " even";
    } else if(align === "around") {
      name = name + " around";
    } else if(align === "between") {
      name = name + " between";
    } else if(whitelabel && whitelabel.userID === "CF8B5B76-0C59-4DD6-9347-A22C336F97E4") {
      name = name + " centered";
    } else {
      name = name + " left";
    }

    return name;
  };

  const embeddingBackgroundColor = () => {
    let color = 'white';
    if(isEmbedded && !transparentNavbar) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const bgcolor = urlParams.get("bgcolor");
      color = bgcolor;
    }
    return color;
  };

  return (
    <StyledMenu
      id="navbar"
      className={navBarClassName()}
      radius={
        whitelabel.socialPlatformButtonsCornerRadius
          ? whitelabel.socialPlatformButtonsCornerRadius
          : "0"
      }
      background={transparentNavbar ? "transparent" : embeddingBackgroundColor()}
    >
      {
        allPlatforms.map((thisPlatform) => {
          if(props.socialNetworks[thisPlatform]) {
            const strategy = platformStrategy(thisPlatform);
            if(isMobile || !strategy.config.onlyMobile) {
              return (
                <Menu.Item onClick={() => toPlatform(thisPlatform)}>
                  <ImageToggleOnMouseOver
                    selected={platform === thisPlatform}
                    inactiveImg={strategy.res.logo_dark}
                    activeImg={strategy.res.logo}
                    alt={strategy.config.platformName}
                    title={strategy.config.platformName}
                    className={`nav-btn ${thisPlatform}-nav-btn`}
                    platformColor={strategy.config.color}
                  />
                </Menu.Item>
              )
            }
          }
          return null; 
        })
      }
    </StyledMenu>
  );
};

export default Navbar;
